import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=19c3084e&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=19c3084e&prod&scoped=true&lang=scss"
import style1 from "./footer.vue?vue&type=style&index=1&id=19c3084e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c3084e",
  null
  
)

export default component.exports